module.exports = __webpack_public_path__ + "static/media/ic-bad-sel.a1d08cb8.svg";